<template>
  <c-button
    left-icon="download"
    variation="solid"
    background="brand.beige"
    border-color="brand.beige"
    @click="onDownloadInternationalForm()"
  >
    {{ $t("productReturn.pastReturns.proFormaLabel") }}
  </c-button>
</template>

<script lang="ts">
import { IRootState } from "@iloq/shared";
import { CButton } from "@chakra-ui/vue";
import { defineComponent } from "vue";
import { mapState } from "vuex";

export default defineComponent({
  components: {
    CButton,
  },
  name: "RMADownloadInternationalForm",
  props: {
    returnId: {
      type: String,
      required: true,
    },
    returnType: {
      type: String,
      required: true,
    },
  },
  computed: mapState({
    user: (state: unknown) => (state as IRootState).user!,
  }),
  methods: {
    onDownloadInternationalForm(): void {
      const email = this.user.email;
      this.$store.dispatch("fetchDownloadToken").then((downloadToken) => {
        const url = `/api/v1/returns/internationalForm/${email}/${this.returnId}?auth_token=${downloadToken}&return_type=${this.returnType}`;
        window.open(url, "_blank");
      });
    },
  },
});
</script>

<style lang="scss">
@import "../../design-system/assets/tokens/tokens";
a.proforma-link {
  display: table;
  cursor: pointer;
  .icon {
    margin: 0 0;
    padding: 0;
    display: table-cell;
    vertical-align: middle;
    svg {
      width: 16px;
      height: 16px;
      fill: $color-iloq-blue-light !important;
    }
  }
  span {
    display: table-cell;
    padding: 0 10px 0 0;
    font-size: 16px;
    color: $color-iloq-blue-light;
    font-weight: 0;
  }
  &:hover {
    .icon svg {
      fill: $color-iloq-green !important;
    }
    span {
      color: $color-iloq-green !important;
    }
  }
}
</style>
